import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";

interface UseReviewContactProps {
  contactId?: string
  privateCompanyLeadId?: string
  state?: string
  onSuccess: (response: AxiosResponse) => void
  onError: () => void
}

const useReviewContact = ({ contactId, privateCompanyLeadId, state, onSuccess, onError }: UseReviewContactProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['reviewContact'],
    mutationFn: (data?: { description?: string }) => {
      const private_company_lead = {
        contacts_attributes: [
          {
            id: contactId,
            last_review_attributes: {
              state,
              description: data?.description
            }
          }
        ]
      }

      return privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useReviewContact
